import React, { useState } from "react";
import { isWithinWATBusinessHours } from "../../../../utils/helpers";
import { SwapButtonDiv, SwapWrappBtn } from "../../AllWallets/style";
import { Button } from "../../../../components/common/Button";
import { useAppSelector } from "../../../../app/hooks";
import { useNavigate } from "react-router-dom";
import { ReactComponent as RecycleIcon } from "../../assets/recycle-icon.svg";
import { ReactComponent as InfoIcon } from "../../../../assets/icons/info.svg";
import { Tooltip } from "antd";

type SwapButtonProps = {
    isMobile?: boolean;
}

export default function SwapButton({ isMobile = false }: SwapButtonProps) {

    const navigate = useNavigate();

    const { business } = useAppSelector((state) => state.settings);
    const [tooltipVisible, setTooltipVisible] = useState(false);

    const tooltipText = "Currency swap is only available between 6am and 6pm WAT. Please try again during these hours.";

    const handleTooltipVisibility = () => {
        if (!isWithinWATBusinessHours()) {
            setTooltipVisible(!tooltipVisible);
        }
    }

    return (
        <SwapButtonDiv isMobile={isMobile} onMouseEnter={handleTooltipVisibility} onMouseLeave={!isMobile ? handleTooltipVisibility : null}>
            <Button
                height="40px"
                width="100%"
                fontSize="12px"
                onClick={() => navigate("/wallets/swap/currency?type=amount")}
                disabled={!isWithinWATBusinessHours() || !business?.approved}
            >
                <SwapWrappBtn>
                    {
                        isWithinWATBusinessHours() ?
                            <RecycleIcon /> :
                            <Tooltip
                                overlayClassName="input-tooltip"
                                placement="top"
                                title={tooltipText}
                                trigger={["hover", "click"]}
                                className="tool-tip"
                                onOpenChange={setTooltipVisible}
                                open={tooltipVisible}
                            >
                                <InfoIcon />
                            </Tooltip>
                    }
                    <span>Swap currency</span>
                </SwapWrappBtn>
            </Button>
        </SwapButtonDiv>
    )
}